export const LOCAL_STORAGE_KEY = 'user-registration-modal-form-values'

export const EMPTY_STATE = {
  name: '',
  email: '',
  phone: '',
  address: '',
  postalCode: '',
  postOffice: '',
  termsAgree: false,
}
